class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();
    const headerSearch = document.querySelector('.js-header-search');
    this.mq = window.matchMedia('(max-width: 1200px)');

    this.addEventListener("click", function (evt) {
      evt.preventDefault();

      if (this.mq.matches && document.body.classList.contains('search-open')) return;

      if (this.getAttribute("data-drawer") == "all") {
        closeActiveDrawers();
      } else {
        if (this.classList.contains("drawers-close-active")) {
          closeActiveDrawers();
        }

        //get drawer element by ID from click event target data attribute
        const drawer = document.getElementById(
          this.getAttribute("data-drawer")
        );
        //dispatch event to trigger drawer state
        if (drawer) {
          drawer.dispatchEvent(new CustomEvent("drawer-toggle", {
            detail: {
              focusSearch: this.getAttribute('data-focus-search'),
              search: headerSearch
            }
          }));
        }
      }
    });

    function closeActiveDrawers() {
      const activeDrawers = document.querySelectorAll("side-drawer.active");
      if (!activeDrawers) return;

      activeDrawers.forEach((el) => {
        //Toggle drawer event
        el.dispatchEvent(new Event("drawer-toggle"));
      });
    }
  }
}

customElements.define("side-drawer-toggle", SideDrawerToggle);
